var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 547.448,
    height: 439.954,
    viewBox: "0 0 547.448 439.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_11",
    "data-name": 11,
    transform: "translate(-548.464 -360.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3244",
    "data-name": "Group 3244",
    transform: "translate(768.598 360.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1286.639,376.187a58.575,58.575,0,0,0-35.961-14.828c-1.088-.062-2.176,3.176-3.273,3.176-1.219,0-2.436-3.224-3.645-3.156a58.557,58.557,0,0,0-35.586,14.8c-.853.767-.062,3.187-.885,4.009s-3.238.021-4.012.888a58.557,58.557,0,0,0-14.8,35.789,13.081,13.081,0,0,0,.833,3.565,11.06,11.06,0,0,0-.833,3.348,58.523,58.523,0,0,0,14.818,35.772,9.217,9.217,0,0,0,3.4,1.5l40.786-37.51,40.972-44.176a11.52,11.52,0,0,0-1.813-3.176Z",
    transform: "translate(-1188.366 -361.265)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1324.979,416l-71.747,71.747s-8.493,11.766-7.629,12.523a58.575,58.575,0,0,0,35.917,14.839c1.094.055,2.2-3.17,3.317-3.17,1.208,0,2.409,3.225,3.6,3.152a58.544,58.544,0,0,0,35.631-14.8c.857-.764-1.562-4.818-.743-5.637s4.873,1.6,5.636.743a58.538,58.538,0,0,0,14.8-35.789,9.3,9.3,0,0,0-1.418-3.5,8.775,8.775,0,0,0,1.411-3.441,58.555,58.555,0,0,0-14.818-35.752C1328.29,416.162,1324.979,416,1324.979,416Z",
    transform: "translate(-1225.791 -397.104)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1356.233,380.778l-.189-19.588c-1.091-.062-2.175-.1-3.27-.1q-1.827,0-3.644.117l.189,19.564Z",
    transform: "translate(-1293.732 -361.09)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1245.351,606.44l-13.841,13.844q1.146,1.29,2.371,2.519h0l7.13-3.868,6.786-10.045Z",
    transform: "translate(-1216.589 -522.008)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1254.774,615.99l-2.447-2.45-13.937,13.923q1.229,1.229,2.519,2.374Z",
    transform: "translate(-1221.101 -526.665)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1447.321,404.47l-13.841,13.844,2.447,2.447,9.522-6.26,4.384-7.657S1448.185,405.234,1447.321,404.47Z",
    transform: "translate(-1349.055 -389.542)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1456.871,413.879q-1.143-1.291-2.375-2.519l-13.916,13.917,2.447,2.45Z",
    transform: "translate(-1353.712 -394.061)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1349.66,647.054l.148,19.584q1.641.083,3.314.089c1.2,0,2.409-.034,3.6-.11l-.148-19.567Z",
    transform: "translate(-1294.08 -548.643)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1433.48,611.337l13.841,13.841c.86-.764,1.7-1.552,2.522-2.374s1.607-1.659,2.375-2.519l-13.844-13.844Z",
    transform: "translate(-1349.055 -522.008)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1250.288,418.3l-13.844-13.844c-.857.771-1.7,1.555-2.522,2.375s-1.611,1.662-2.371,2.519l13.841,13.844Z",
    transform: "translate(-1216.615 -389.535)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1474.09,529.54h19.584c.069-1.149.1-2.3.1-3.459s-.034-2.312-.1-3.462h-19.584Z",
    transform: "translate(-1375.69 -467.033)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M1207.831,522.62H1188.25q-.1,1.721-.1,3.441,0,1.74.1,3.465h19.577Z",
    transform: "translate(-1188.15 -467.033)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M1308.2,420.6a42.821,42.821,0,0,0-60.749,60.367l.193.193,30.493-27.227Z",
    transform: "translate(-1218.879 -391.835)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M1332.267,505.237a42.868,42.868,0,0,0,0-60.567L1271.7,505.237A42.871,42.871,0,0,0,1332.267,505.237Z",
    transform: "translate(-1242.948 -415.908)",
    fill: "#ffd664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M8s_white_background",
    "data-name": "M8s white background",
    transform: "translate(31.4 33.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    "data-name": "Path 4167",
    d: "M1314.583,503.157a14.3,14.3,0,0,0,1.033-11.115c-.176-.668-.227-1.376-.368-2.24,8.6,3.262,15.534-1.225,17.423-8.49,1.435-5.506-1.129-10.51-4.512-14.615a27.78,27.78,0,0,0-2.206-2.381,33.133,33.133,0,0,0-6.776-5.021,16.14,16.14,0,0,0-8.968-2.065c-7.313.764-13.837,8.6-10.014,17.251a5.355,5.355,0,0,1-1.824.1c-7.1-2.258-12.568-.293-16.6,6.019a14.955,14.955,0,0,0-1.449,13.077,23.432,23.432,0,0,0,6.47,9.8c.492.478,1,.95,1.514,1.407,4.439,3.961,9.55,6.411,15.524,5.42C1308.268,509.564,1312.181,507.747,1314.583,503.157Zm-15.32-3.07a6.5,6.5,0,0,1-3.971-3c-.148-.279-.276-.523-.413-.733l-.079-.12a.284.284,0,0,0-.059-.086,1.523,1.523,0,0,0-.1-.145.848.848,0,0,0-.069-.086c-.034-.041-.073-.086-.114-.127s-.066-.072-.1-.107a1.557,1.557,0,0,0-.161-.141c-.062-.048-.131-.1-.2-.148a2.892,2.892,0,0,0-.317-.186.131.131,0,0,0-.048-.028l-.134-.062a4.33,4.33,0,0,0-.423-.165c-1.855-.661-3.517-2.1-3.287-4.45.255-2.453,1.906-3.748,4.264-3.933,3.1-.248,6.194-.293,10.079-.451-.32,3.964-.606,7.316-.857,10.668C1303.093,499.323,1301.327,500.49,1299.263,500.087Zm19.02-19.368c-.344.048-.716.086-1.077.117s-.715.058-1.081.083c-2.185.134-4.473.117-6.989.2h-.43c.313-3.875.344-7.185.922-10.382.392-2.14,1.7-4.054,4.377-3.985,2.478.058,3.465,1.893,4.37,3.827l.086.172a3.95,3.95,0,0,0,.234.344,2.321,2.321,0,0,0,.227.227l.1.083a1.09,1.09,0,0,0,.151.107l.1.058.114.052c2.733,1.053,4.071,2.932,3.872,5.241-.248,3.152-2.729,3.575-4.962,3.861Z",
    transform: "translate(-1279.439 -457.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    "data-name": "Path 4168",
    d: "M1374.861,507.651c-.344.045-.716.086-1.077.117l-1.08.083c-2.185.134-4.474.114-6.993.2l9.791-9.787.1.083a.93.93,0,0,0,.152.107l.1.058.117.052c2.733,1.053,4.071,2.932,3.872,5.241C1379.575,506.942,1377.094,507.366,1374.861,507.651Z",
    transform: "translate(-1336.007 -484.129)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    "data-name": "Path 4169",
    d: "M1327.831,555.208a6.493,6.493,0,0,1-3.971-3c-.148-.279-.279-.52-.413-.73-.028-.041-.049-.083-.079-.12a.364.364,0,0,0-.058-.089c-.035-.052-.069-.093-.1-.141a.833.833,0,0,0-.069-.086,1.3,1.3,0,0,0-.117-.127l9.674-9.673c-.316,3.964-.6,7.316-.853,10.668C1331.658,554.441,1329.9,555.611,1327.831,555.208Z",
    transform: "translate(-1308.007 -512.319)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    "data-name": "Path 4170",
    d: "M1314.011,466.778c-2.677-.069-3.988,1.844-4.377,3.989-.589,3.2-.609,6.507-.922,10.382h.43l-5.007,5c-3.875.158-6.986.206-10.076.451-2.357.186-4.012,1.483-4.264,3.937-.241,2.35,1.428,3.785,3.286,4.446.155.055.3.114.423.165l.134.065a.114.114,0,0,1,.045.024,2.279,2.279,0,0,1,.316.189,2,2,0,0,1,.207.148,2.039,2.039,0,0,1,.162.138,1.4,1.4,0,0,1,.1.107l-7.678,7.677a23.446,23.446,0,0,1-6.469-9.808c-1.4-4.494-1.225-8.91,1.446-13.077,4.029-6.315,9.5-8.28,16.6-6.019a5.253,5.253,0,0,0,1.82-.1c-3.827-8.665,2.7-16.487,10.011-17.251a16.139,16.139,0,0,1,8.968,2.065,33.16,33.16,0,0,1,6.776,5.021l-7.013,7.017a2.028,2.028,0,0,1-.227-.227,3.243,3.243,0,0,1-.234-.344,1.616,1.616,0,0,1-.086-.172C1317.494,468.671,1316.486,466.837,1314.011,466.778Z",
    transform: "translate(-1279.432 -457.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    "data-name": "Path 4171",
    d: "M1314.583,503.157a14.3,14.3,0,0,0,1.033-11.115c-.176-.668-.227-1.376-.368-2.24,8.6,3.262,15.534-1.225,17.423-8.49,1.435-5.506-1.129-10.51-4.512-14.615a27.78,27.78,0,0,0-2.206-2.381,33.133,33.133,0,0,0-6.776-5.021,16.14,16.14,0,0,0-8.968-2.065c-7.313.764-13.837,8.6-10.014,17.251a5.355,5.355,0,0,1-1.824.1c-7.1-2.258-12.568-.293-16.6,6.019a14.955,14.955,0,0,0-1.449,13.077,23.432,23.432,0,0,0,6.47,9.8c.492.478,1,.95,1.514,1.407,4.439,3.961,9.55,6.411,15.524,5.42C1308.268,509.564,1312.181,507.747,1314.583,503.157Zm-15.32-3.07a6.5,6.5,0,0,1-3.971-3c-.148-.279-.276-.523-.413-.733a1.4,1.4,0,0,0-.079-.12,2.62,2.62,0,0,0-.23-.317c-.034-.041-.073-.086-.114-.127a2.12,2.12,0,0,0-.461-.4,2.939,2.939,0,0,0-.317-.186,1.692,1.692,0,0,0-.241-.114c-.117-.052-.237-.1-.344-.141-1.855-.661-3.52-2.1-3.286-4.45.255-2.454,1.906-3.748,4.264-3.933,3.1-.248,6.194-.293,10.076-.451-.317,3.964-.6,7.316-.854,10.668C1303.093,499.323,1301.327,500.49,1299.263,500.087Zm19.02-19.368c-.293.038-.589.076-.891.1-.516.052-1.032.089-1.566.12-.313,0-.623.031-.943.038-.385.017-.774.028-1.17.038l-2.732.055c-.523,0-1.063.024-1.617.038h-.664c.316-3.878.344-7.189.926-10.386.389-2.141,1.7-4.057,4.374-3.988,2.478.058,3.465,1.893,4.37,3.83a2.333,2.333,0,0,0,.544.733.758.758,0,0,0,.1.083,1.415,1.415,0,0,0,.365.22c2.732,1.053,4.071,2.932,3.872,5.241-.241,3.169-2.722,3.593-4.956,3.878Z",
    transform: "translate(-1279.439 -457.198)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    "data-name": "Path 4172",
    d: "M1374.847,507.632c-.3.041-.592.076-.891.1-.516.052-1.032.09-1.566.117-.313.021-.626.038-.946.041-.382.017-.771.028-1.17.038-.881.021-1.793.038-2.729.052l-1.617.041h-.238l9.794-9.79a.713.713,0,0,0,.1.083,1.286,1.286,0,0,0,.368.217c2.729,1.056,4.071,2.935,3.871,5.245C1379.562,506.919,1377.081,507.346,1374.847,507.632Z",
    transform: "translate(-1335.994 -484.11)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    "data-name": "Path 4173",
    d: "M1327.831,555.208a6.493,6.493,0,0,1-3.971-3c-.148-.279-.279-.52-.413-.73-.028-.041-.049-.083-.079-.12a3.021,3.021,0,0,0-.231-.317,1.3,1.3,0,0,0-.117-.127l9.674-9.673c-.316,3.964-.6,7.316-.853,10.668C1331.658,554.441,1329.9,555.611,1327.831,555.208Z",
    transform: "translate(-1308.007 -512.319)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    d: "M1323.831,541.25l-9.674,9.67a2.1,2.1,0,0,0-.461-.392,2.253,2.253,0,0,0-.317-.189,1.26,1.26,0,0,0-.24-.11,3.373,3.373,0,0,0-.344-.145c-1.855-.661-3.521-2.1-3.286-4.45.255-2.45,1.906-3.748,4.264-3.933C1316.845,541.453,1319.952,541.408,1323.831,541.25Z",
    transform: "translate(-1299.131 -512.325)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    d: "M1374.681,489.527l-9.791,9.787h-.43c.313-3.875.344-7.182.926-10.379.389-2.141,1.7-4.057,4.374-3.988,2.478.058,3.469,1.893,4.371,3.827a2.373,2.373,0,0,0,.551.754Z",
    transform: "translate(-1335.187 -475.396)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    "data-name": "Path 4176",
    d: "M1313.975,466.778c-2.678-.069-3.989,1.844-4.377,3.989-.588,3.2-.609,6.507-.922,10.382h.43l-5.007,5c-3.875.158-6.986.206-10.076.451-2.357.186-4.013,1.483-4.264,3.937-.241,2.35,1.428,3.785,3.286,4.446a3.3,3.3,0,0,1,.344.145,1.372,1.372,0,0,1,.24.11,2.451,2.451,0,0,1,.317.189,2.01,2.01,0,0,1,.461.392l-7.674,7.674a23.451,23.451,0,0,1-6.473-9.808c-1.4-4.494-1.225-8.909,1.445-13.077,4.03-6.311,9.5-8.276,16.6-6.019a5.27,5.27,0,0,0,1.824-.1c-3.827-8.662,2.7-16.484,10.01-17.248a16.139,16.139,0,0,1,8.968,2.065,33.159,33.159,0,0,1,6.776,5.021l-7.013,7.017a2.352,2.352,0,0,1-.547-.736C1317.457,468.671,1316.449,466.837,1313.975,466.778Z",
    transform: "translate(-1279.395 -457.211)",
    fill: "#fdae02"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12146",
    "data-name": "Path 12146",
    d: "M1271.771,1341.674c14.212-19.13,25.631-19.3,25.631-19.3s5.162-33.611,1.033-47.906-22.826-1.762-22.826-1.762,24.777-48.577,14.618-54.028c-18.927-10.166-48.76,41.364-48.76,41.364s6.986-22.682-6.4-22.6c-20.19.124-21.938,52.128-21.938,52.128s-3.981-10.245-16.439-4.374c-13.421,6.322-17.052,44.393-17.816,73.819h70.735C1259.74,1352.817,1268.006,1346.739,1271.771,1341.674Z",
    transform: "translate(-413.466 -561.807)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12147",
    "data-name": "Path 12147",
    d: "M1241.154,1255.686s.833-25.844-12.557-25.757c-20.19.124-18.26,59.434-18.26,59.434s-8.435-16.78-20.892-10.909c-13.672,6.442-15.3,48.522-14.76,80.354h23.5l89.256-140.343C1268.505,1208.3,1241.154,1255.686,1241.154,1255.686Z",
    transform: "translate(-410.665 -561.601)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12148",
    "data-name": "Path 12148",
    d: "M1687.5,1483.919s64.458,7.423,80.075,1.955,5.272-14.213,5.272-14.213,33.036-4.219,36.209-14.047-12.44-9.89-12.44-9.89,33.146-18.287,29.427-25.38c-6.931-13.208-44.124,4.818-44.124,4.818s12.839-10.324,5.11-15.486c-11.659-7.784-32.9,21.436-32.9,21.436s1.7-7.44-7.746-8.913C1729.439,1421.56,1687.5,1483.919,1687.5,1483.919Z",
    transform: "translate(-747.062 -688.395)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12149",
    "data-name": "Path 12149",
    d: "M1758.136,1408.329c9.443,1.472,7.763,14.4,7.763,14.4s21.962-34.85,33.621-27.069c7.729,5.162-2.8,19.694-2.8,19.694s34.158-16.6,41.089-3.393l-132.369,57.446C1710.3,1462.1,1742.307,1405.864,1758.136,1408.329Z",
    transform: "translate(-758.828 -678.013)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12150",
    "data-name": "Path 12150",
    d: "M1667.482,1317.293s58.657-40.81,67.105-58.753-7.722-16.446-7.722-16.446,24.123-31.774,18.393-42.751-18.9,2.326-18.9,2.326,12.2-43.7,3.015-46.457c-17.114-5.162-33.855,50.164-33.855,50.164s-6.39-30.627-17.3-28.339c-16.446,3.441-.038,48.69-.038,48.69s-4.849-14.742-14.041-7.915C1647.65,1230.081,1667.482,1317.293,1667.482,1317.293Z",
    transform: "translate(-727.444 -520.83)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12151",
    "data-name": "Path 12151",
    d: "M1624.259,1218.31A23.33,23.33,0,0,0,1636.7,1203.1s.069-25.593,16.518-29.024c10.906-2.275,18.538,18.287,18.538,18.287s16.673-42.545,33.786-37.376l-62.063,161.4C1641.306,1306.124,1611.925,1224.146,1624.259,1218.31Z",
    transform: "translate(-703.608 -520.621)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12152",
    "data-name": "Path 12152",
    d: "M1395.341,1601.188h-118.28a6.831,6.831,0,0,1-6.831-6.831h0a6.831,6.831,0,0,1,6.831-6.827h118.28a6.831,6.831,0,0,1,6.831,6.827h0A6.831,6.831,0,0,1,1395.341,1601.188Z",
    transform: "translate(-473.386 -804.598)",
    fill: "#fc7770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12153",
    "data-name": "Path 12153",
    d: "M1455.461,1562.666H1337.181a6.831,6.831,0,0,1-6.831-6.831h0a6.831,6.831,0,0,1,6.831-6.834h118.281a6.831,6.831,0,0,1,6.827,6.831h0A6.831,6.831,0,0,1,1455.461,1562.666Z",
    transform: "translate(-512.817 -779.327)",
    fill: "#d73223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12154",
    "data-name": "Path 12154",
    d: "M1407.368,1526.188h-118.28a6.831,6.831,0,0,1-6.828-6.831h0a6.827,6.827,0,0,1,6.828-6.827h118.28a6.831,6.831,0,0,1,6.831,6.827h0A6.831,6.831,0,0,1,1407.368,1526.188Z",
    transform: "translate(-481.277 -755.407)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12155",
    "data-name": "Path 12155",
    d: "M1367.271,1486.659H1248.981a6.831,6.831,0,0,1-6.831-6.827h0a6.831,6.831,0,0,1,6.831-6.831h118.281a6.831,6.831,0,0,1,6.827,6.831h0a6.827,6.827,0,0,1-6.817,6.827Z",
    transform: "translate(-454.97 -729.481)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12156",
    "data-name": "Path 12156",
    d: "M798.234,1205s-91.882-45.315-107.712-68.946,7.426-24.973,7.426-24.973-41.01-39.885-35.239-56.678,27.3-.743,27.3-.743-26.649-59.348-14.216-65.247c23.16-10.991,55.649,52.166,55.649,52.166s-6.982-27.437,8.947-26.546c24.051,1.345,23.057,63.409,23.057,63.409s2.719-23.8,17.206-16.067C806.685,1075.242,798.234,1205,798.234,1205Z",
    transform: "translate(-74.565 -410.81)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12157",
    "data-name": "Path 12157",
    d: "M811.908,1051.779c-11.322-6.28-22.6,12.079-22.6,12.079s1.142-48.474-22.909-49.819c-15.947-.891-8.947,26.546-8.947,26.546S724.95,977.42,701.79,988.412l122.544,215.579C825.2,1188.935,834.331,1064.216,811.908,1051.779Z",
    transform: "translate(-100.562 -410.81)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12158",
    "data-name": "Path 12158",
    d: "M737.559,1437.587s-75.161,9.336-94.635,1.032-5.506-18.583-5.506-18.583-41.787-8.215-45.012-21.033,16.725-11.559,16.725-11.559-40.735-26.209-35.376-34.943c9.98-16.267,55.907,9.925,55.907,9.925s-15.486-14.274-5.193-20.2c15.548-8.948,40.146,30.183,40.146,30.183s-1.528-9.635,10.668-10.709C697.128,1359.779,737.559,1437.587,737.559,1437.587Z",
    transform: "translate(-16.269 -642.837)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12159",
    "data-name": "Path 12159",
    d: "M676.66,1341.24c-12.182,1.067-11.146,17.716-11.146,17.716s-25.046-46.368-40.607-37.434c-10.324,5.926,1.889,25.383,1.889,25.383s-42.176-24.123-52.156-7.856L738.675,1423.7C733.111,1413.972,697.077,1339.444,676.66,1341.24Z",
    transform: "translate(-17.168 -629.381)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12160",
    "data-name": "Path 12160",
    d: "M596.27,1629.063h0a2.113,2.113,0,0,0,2.113,2.113h526.77a2.113,2.113,0,0,0,2.113-2.113h0a2.113,2.113,0,0,0-2.113-2.113H598.383A2.113,2.113,0,0,0,596.27,1629.063Z",
    transform: "translate(-31.355 -830.452)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12161",
    "data-name": "Path 12161",
    d: "M1613.744,565.16l-2.677,6.68-11.225-3.125L1594.721,578l-8.782-.964-.489,4.446,11.745,1.291,4.852-8.8,11.677,3.252,4.033-10.052Z",
    transform: "translate(-680.13 -134.054)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12162",
    "data-name": "Path 12162",
    d: "M1964.324,1217.94l-2.681,6.68-11.222-3.125-5.124,9.281-8.782-.964-.485,4.446,11.742,1.291,4.855-8.8L1964.3,1230l4.033-10.052Z",
    transform: "translate(-910.066 -562.194)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12163",
    "data-name": "Path 12163",
    d: "M1059.319,1588.8H920.391a10.021,10.021,0,0,1-10.021-10.021h0a10.017,10.017,0,0,1,10.021-10.021h138.928a10.021,10.021,0,0,1,10.024,10.021h0A10.024,10.024,0,0,1,1059.319,1588.8Z",
    transform: "translate(-237.364 -792.287)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12164",
    "data-name": "Path 12164",
    d: "M1135.51,1531.136H1004.725a10.024,10.024,0,0,1-10.025-10.021h0a10.025,10.025,0,0,1,10.025-10.025H1135.51a10.021,10.021,0,0,1,10.021,10.025h0A10.021,10.021,0,0,1,1135.51,1531.136Z",
    transform: "translate(-292.674 -754.463)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 144.696,
    height: 20.052,
    rx: 10.026,
    transform: "translate(689.304 736.572)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 144.943,
    height: 20.045,
    rx: 10.023,
    transform: "translate(688.76 716.581)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12165",
    "data-name": "Path 12165",
    d: "M1100.55,1359.932H973.7A10.024,10.024,0,0,1,963.68,1349.9h0A10.025,10.025,0,0,1,973.7,1339.88H1100.55a10.021,10.021,0,0,1,10.021,10.021h0A10.024,10.024,0,0,1,1100.55,1359.932Z",
    transform: "translate(-272.329 -642.171)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12166",
    "data-name": "Path 12166",
    d: "M1084.647,1302.432H957.8a10.018,10.018,0,0,1-10.021-10.021h0A10.021,10.021,0,0,1,957.8,1282.39h126.845a10.021,10.021,0,0,1,10.021,10.021h0A10.021,10.021,0,0,1,1084.647,1302.432Z",
    transform: "translate(-261.9 -604.465)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 141.148,
    height: 20.045,
    rx: 10.023,
    transform: "translate(697.776 639.204)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 136.013,
    height: 20.045,
    rx: 10.023,
    transform: "translate(713.62 658.475)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12167",
    "data-name": "Path 12167",
    d: "M1529.373,759.576l6.611-3.345,6.508,3.548a1.033,1.033,0,0,0,1.494-1.05l-1.143-7.323,5.385-5.09a1.032,1.032,0,0,0-.537-1.745l-7.323-1.177-3.176-6.7a1.032,1.032,0,0,0-1.824-.028l-3.383,6.594-7.347.953a1.032,1.032,0,0,0-.592,1.721l5.224,5.255-1.376,7.282a1.032,1.032,0,0,0,1.479,1.1Z",
    transform: "translate(-639.677 -246.192)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12168",
    "data-name": "Path 12168",
    d: "M1104.306,379.016l-6.834.692-2.33-10.871-10.114-.217-3.073-7.85-3.975,1.555,4.113,10.5,9.584.206,2.426,11.308,10.279-1.043Z",
    transform: "translate(-347.295 0)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12169",
    "data-name": "Path 12169",
    d: "M611.956,898.656l-6.834.692-2.33-10.871-10.114-.217-3.073-7.85-3.975,1.556,4.112,10.5,9.584.207,2.426,11.308,10.279-1.043Z",
    transform: "translate(-24.376 -340.817)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12170",
    "data-name": "Path 12170",
    d: "M1659.487,972.782l7.44-1.975s7.657-9.477,7.32-12.079-3.193-7.571-1.9-8.6a4.993,4.993,0,0,1,7.037.544c2.017,2.086,3.022,11.257,4.044,11.635.644.234,4.952-.778,8.087-1.569a5.692,5.692,0,0,1,5.668,1.789h0a3.146,3.146,0,0,1,.2,3.9l-1.318,1.827,1.748,1.452a3.142,3.142,0,0,1,.465,4.343l-1.067,1.346,1.16.822a3.135,3.135,0,0,1,.571,4.577l-.967,1.122.258.286a3.132,3.132,0,0,1,0,4.181l-.981,1.081-19.815,5.259a13.9,13.9,0,0,1-5.7.3l-7.279.688a1.607,1.607,0,0,1-1.7-1.225l-4.411-17.729a1.6,1.6,0,0,1,1.132-1.962Z",
    transform: "translate(-727.911 -385.751)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12171",
    "data-name": "Path 12171",
    d: "M549.054,1243.2l4.295-4.443s1.335-9.684.024-11.336-5.334-3.885-4.873-5.131a4.006,4.006,0,0,1,5.062-2.54c2.25.6,6.741,6.484,7.6,6.322.54-.1,3.1-2.585,4.907-4.429a4.573,4.573,0,0,1,4.639-1.118h0a2.519,2.519,0,0,1,1.752,2.595l-.148,1.8,1.8.272a2.522,2.522,0,0,1,2.12,2.791l-.175,1.376,1.139.086a2.522,2.522,0,0,1,2.288,2.911l-.2,1.17.3.093a2.512,2.512,0,0,1,1.721,2.87l-.227,1.149-11.439,11.814a11.113,11.113,0,0,1-3.785,2.564l-4.718,3.486a1.287,1.287,0,0,1-1.673-.138l-10.379-10.358A1.284,1.284,0,0,1,549.054,1243.2Z",
    transform: "translate(0 -563.258)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12172",
    "data-name": "Path 12172",
    d: "M760.625,729.052c-.1-.269-2.385-4.181-5.341-8.435-13.745-19.8-34.131-38.886-58.034-38.177V682.3c10.809-1.184,21.4,1.693,30.693,6.824,15.338,8.259,30.283,24.02,38.453,36.133Z",
    transform: "translate(-97.585 -210.706)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12173",
    "data-name": "Path 12173",
    d: "M1337.513,696.955a11.555,11.555,0,0,0,.661-4.69,80.088,80.088,0,0,0-1.033-10.7c-.292-.978,12.8-5.079,12.8-5.079s21.009-1.077,24.137-3.421,5.757-3.314,4.3-.881c-2.639,4.4-8.8,10.847-10.162,11.728s-17.688,4.983-17.981,4.983-.2,10.259-.2,10.259Z",
    transform: "translate(-517.268 -203.317)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12174",
    "data-name": "Path 12174",
    d: "M1240.665,731.527s-13.6-2.312-13.851-.953c-5.506,30.1-6.428,40.046-7.034,40.359-2.064,1.063-31.68-24.922-36.574-26.622a20.111,20.111,0,0,0-7.326-.606c-5.823.172-3.858.031-6.927.183h-.261l.031,5.475c6.56,5.9,21.574,95.272,22.837,95.21,1.414-.065,31.085,7.4,30.562,4.9-.086-.406-20.118-16.8-25.81-40.459-1.91-7.939-2.849-16.491-3.885-23.975,6.593,3.3,32.348,15.978,36.426,14.3C1241.563,794.162,1240.665,731.527,1240.665,731.527Z",
    transform: "translate(-406.789 -242.263)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12175",
    "data-name": "Path 12175",
    d: "M1526.34,1176.886s27.606,21.625,28.528,25.465c1.325,5.506,26.6-1.721,20.51-2.86-1.4-.258-5.891-1.4-6.26-1.6-1.975-1.053-26.539-30.655-26.539-30.655Z",
    transform: "translate(-641.362 -528.941)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12176",
    "data-name": "Path 12176",
    d: "M1639.724,1258.2l-17.626-1.438s-5.038,4.171-14.722,4.367a22.558,22.558,0,0,0-.812,9.594c.127.891.275,3.586,1.173,3.527,3.259-.224,11.935-2.381,21.821-4.36,0,0,13.287-2.812,20.961-7.4S1639.724,1258.2,1639.724,1258.2Z",
    transform: "translate(-693.852 -587.655)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12177",
    "data-name": "Path 12177",
    d: "M1153.573,1017.695a120.685,120.685,0,0,0,42.576-1.834c25.871-6.053,54.482-11.649,62.862-6.776,6.749,3.923,48.866,67.587,48.866,67.587l-16.271,11.872-46.392-51.963s-59.19,21.838-72.48,19.416C1142.475,1050.511,1142.045,1026.326,1153.573,1017.695Z",
    transform: "translate(-392.295 -423.995)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12178",
    "data-name": "Path 12178",
    d: "M1188.984,1000.31l20.228,24.037-37.527,11.432-4.8-22.623Z",
    transform: "translate(-405.602 -419.456)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12179",
    "data-name": "Path 12179",
    d: "M1346.708,1319.39s-1.228,33.381-1.992,39.045,14.171,22.585,12.265,16.687c-.44-1.356-1.569-5.85-1.573-6.267,0-2.237,5.537-40.329,5.537-40.329Z",
    transform: "translate(-522.221 -628.732)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12180",
    "data-name": "Path 12180",
    d: "M1335.577,1460.059l-7.109-16.191s-6.063-2.45-10.837-10.878a22.583,22.583,0,0,0-8.827,3.844c-.723.533-5.661,4.129-5.317,4.979,1.266,3.066,7.987,9.636,15.341,16.807,0,0,10.42,8.4,18.108,12.977S1335.577,1460.059,1335.577,1460.059Z",
    transform: "translate(-495.188 -703.239)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12181",
    "data-name": "Path 12181",
    d: "M1226.2,1034.779c-7.069-9.426-64.125-18.38-64.125-18.38L1146.17,985.82l-35.18,21.68s3.517,27.995,6.156,35.473c3.517,9.98,27.159,10.475,41.6,10.324,13.287-.134,37.555,2.574,37.555,2.574l-8.221,72.429s16.133,3.672,20.668,3.076C1209.273,1131.311,1235,1046.507,1226.2,1034.779Z",
    transform: "translate(-368.945 -409.953)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12182",
    "data-name": "Path 12182",
    d: "M1128.964,770.29l-19.849,1.088s-.454.162-.592.186c-1.618.3-.148,58.158,1.294,79.745s4.367,30.679,4.367,30.679,26.921-4.78,35.18-7.987c3.442-1.332,11.728-11.7,11.728-11.7s-8.479-11.4-12.75-29.912c-3.293-14.278-7.354-39.575-9.677-44.871C1133.324,775.38,1128.964,770.29,1128.964,770.29Z",
    transform: "translate(-366.863 -268.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12183",
    "data-name": "Path 12183",
    d: "M1112.165,717.423l-.564,17.523s12.85,22.141,19.443,19.054c5.537-2.588.623-19.429.623-19.429s-.957-3.861-2.289-8.3a32.019,32.019,0,0,1-1.641-8.92C1127.874,711.37,1112.165,717.423,1112.165,717.423Z",
    transform: "translate(-369.345 -232.141)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12184",
    "data-name": "Path 12184",
    d: "M1128.785,606.44s6.538,9.87,7.037,18.177a42.745,42.745,0,0,1-1.27,13.975l-21.013-25.121Z",
    transform: "translate(-370.618 -161.128)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12185",
    "data-name": "Path 12185",
    d: "M1172.852,644.864c.3,2.908-.836,5.406-2.526,5.578s-3.3-2.044-3.6-4.952.833-5.406,2.526-5.578S1172.556,641.956,1172.852,644.864Z",
    transform: "translate(-405.473 -183.075)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12186",
    "data-name": "Path 12186",
    d: "M1093.458,622.631c-.482-.1-.434,24.089,6.573,29.767s19.206,6.194,22.768.458c3.94-6.339.192-31.818-10.231-37.228S1093.458,622.631,1093.458,622.631Z",
    transform: "translate(-357.333 -166.259)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12187",
    "data-name": "Path 12187",
    d: "M1064.307,584.523c-5.352,4.694-7.943,8.118-11.563,16.46-4.449,10.252,4.381,20.878,11.787,25.1s8.032,9.405,8.032,9.405l.292-3.224a8.7,8.7,0,0,0-1.146-5.448c-.633-1.345-2.656-5.964-3.441-7.182-2.085-3.214-2.495-3.909-1.466-6.962.791-2.354-.128-7.536,1.1-11.411l9.98-2.147s6.236-1.5,9.384-5.134C1096.294,583.546,1078.416,571.911,1064.307,584.523Z",
    transform: "translate(-329.957 -143.148)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12188",
    "data-name": "Path 12188",
    d: "M1090.633,677.461c1.225,2.657.97,5.386-.571,6.1s-3.785-.857-5.014-3.51-.974-5.382.568-6.1S1089.4,674.811,1090.633,677.461Z",
    transform: "translate(-351.421 -205.294)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12189",
    "data-name": "Path 12189",
    d: "M654.537,643.98l-1.6-11.139,8.259-7.643a1.549,1.549,0,0,0-.788-2.66l-11.095-1.9-4.718-10.22a1.548,1.548,0,0,0-2.774-.069L636.58,620.3,625.4,621.636a1.548,1.548,0,0,0-.926,2.615l7.856,8.063-2.188,11.04a1.548,1.548,0,0,0,2.2,1.686l10.093-4.98,9.825,5.506a1.545,1.545,0,0,0,2.271-1.587Z",
    transform: "translate(-49.569 -163.148)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12190",
    "data-name": "Path 12190",
    d: "M904.339,434.251c1.132,4.656,3.176,12.01,3.176,12.01-.162,2.023-.76,10.437-1.469,20.751l15.142-6.067s-.179-16.8.5-17.833c.571-.871,1.535.213,6.194-6.435,1.342-1.92,1.593-5.348,1.593-5.348s.275-4.222-.671-4.615a1.968,1.968,0,0,0-2.378.967c-.341.73-.258,2.426-.6,3.156s-2.536,1.611-3.462,1.562.117-12.485.117-12.485.516-3.527.778-4.68c.22-.988,1.119-3.871,1.119-3.871s1.032-4.188-.248-4.508c-.768-.189-2.722,3.214-4.061,6.824-1.439,3.889-2.258,8.011-2.671,7.956-.967-.131-.454-6.951-.454-6.951a21.906,21.906,0,0,0,.939-4.6c.912-1.807,1.518-5.162-.086-5.437-.3-.052-2.409,4.209-2.409,4.209s-.829,3-1.315,4.4c-.853,2.471-.984,6.373-1.428,8.094-.372,1.432-.688.843-.86.9s.089-1.927.344-4.642a27.112,27.112,0,0,1,.344-4.5,32.382,32.382,0,0,0,.647-4.749c.261-3.527-1.962-3.166-2.729.059-.292,1.229-.6,2.571-.905,3.93-1.194,5.289-1.16,10.382-1.721,10.427-.74.055-.251-9.223-.251-9.223s-1.139-5.134-2.264-.368a41.5,41.5,0,0,0-1.156,10.238C904.184,424.77,903.207,429.6,904.339,434.251Z",
    transform: "translate(-233.047 -28.779)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12191",
    "data-name": "Path 12191",
    d: "M964.222,619.371s-19.65-.926-24.726-3.221c-3.1-1.377-28.363-21.766-28.363-21.766l.282-54.551-17.781-1.353s-9.219,60.295-6.025,66.9c3.3,6.817,40.308,34.874,47.71,47.049,4.264,7.017,13.156,102.413,14.5,103.273,9.577,4.983,39.148,9.98,38.453,6.938C969.023,679.084,964.222,619.371,964.222,619.371Z",
    transform: "translate(-221.995 -116.555)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12192",
    "data-name": "Path 12192",
    d: "M1362.44,678.659s5.472-2.347,6.938-2.836,6.157-1.377,6.157-1.377,7.281-7.478,9.136-7.671-4.25,8.159-4.25,8.159l-2.54,2.443s4.1-3.52,4.883-4.009,6.941-9.381,8.5-8.792-2.639,6.841-4.69,10.162-11.436,5.375-11.436,5.375Z",
    transform: "translate(-533.864 -199.24)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12193",
    "data-name": "Path 12193",
    d: "M1467.562,775.7c0,1.466-33.243,1.872-40.132,31.34L1423,805.584c9.87-29.939,42.775-28.752,44.393-29.853.021,0,.031-.031.028-.031Z",
    transform: "translate(-573.584 -272.141)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3244-2",
    "data-name": "Group 3244",
    transform: "translate(578.663 680.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76-2",
    "data-name": "Group 76",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M657.79,1326.347a58.568,58.568,0,0,0-20.238,33.222c-.23,1.063,2.8,2.64,2.629,3.724-.189,1.2-3.565,1.906-3.686,3.1a58.572,58.572,0,0,0,9.1,37.455c.626.964,3.138.558,3.823,1.5s-.485,3.2.251,4.1a58.573,58.573,0,0,0,33.036,20.2,13.009,13.009,0,0,0,3.651-.268,11.216,11.216,0,0,0,3.18,1.345,58.526,58.526,0,0,0,37.641-9.081,9.234,9.234,0,0,0,2.01-3.121L698.456,1372.4,661.18,1325.06A11.538,11.538,0,0,0,657.79,1326.347Z",
    transform: "translate(-636.22 -1312.888)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M710.72,1302.873l59.724,82.027s10.3,10.217,11.188,9.48a58.563,58.563,0,0,0,20.228-33.174c.224-1.074-2.787-2.67-2.615-3.786.186-1.194,3.562-1.879,3.675-3.073a58.531,58.531,0,0,0-9.092-37.51c-.619-.967-5,.795-5.685-.145s2.337-4.563,1.614-5.451a58.544,58.544,0,0,0-33.036-20.2,9.336,9.336,0,0,0-3.682.857,8.72,8.72,0,0,0-3.166-1.924,58.534,58.534,0,0,0-37.623,9.11C711.391,1299.631,710.72,1302.873,710.72,1302.873Z",
    transform: "translate(-685.083 -1289.689)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M657.471,1428.2l-19.381-2.856c-.231,1.067-.434,2.134-.606,3.211q-.279,1.806-.454,3.62l19.357,2.856Z",
    transform: "translate(-636.751 -1378.659)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M867,1555.86l11.525,15.83c.971-.626,1.92-1.273,2.86-1.954h0l-2.684-7.646-8.868-8.259Z",
    transform: "translate(-787.582 -1462.932)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M877.958,1547.89l-2.8,2.037,11.587,15.912q1.4-1.032,2.736-2.12Z",
    transform: "translate(-792.934 -1459.036)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M698.92,1324.78l11.521,15.83,2.8-2.037-4.7-10.379-6.883-5.534S699.808,1324.047,698.92,1324.78Z",
    transform: "translate(-677.343 -1311.314)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M709.72,1317q-1.456.922-2.86,1.952l11.587,15.912,2.8-2.037Z",
    transform: "translate(-682.551 -1307.602)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M919.28,1476.034l19.368,2.9c.227-1.073.427-2.161.606-3.262.189-1.187.344-2.382.451-3.576L920.35,1469.2Z",
    transform: "translate(-821.871 -1407.426)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M898.464,1369.5l15.83-11.525q-.929-1.445-1.954-2.856c-.688-.943-1.377-1.848-2.12-2.753l-15.83,11.525Z",
    transform: "translate(-805.546 -1330.8)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    "data-name": "Path 38",
    d: "M679.29,1520.55l-15.83,11.522c.63.967,1.273,1.924,1.954,2.86s1.394,1.848,2.12,2.753l15.83-11.522Z",
    transform: "translate(-654.086 -1441.104)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    "data-name": "Path 39",
    d: "M822.511,1311.01l3.042-19.34c-1.122-.244-2.257-.458-3.4-.64s-2.292-.327-3.441-.44l-3.046,19.34Z",
    transform: "translate(-753.916 -1290.28)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M774.342,1572.78l-3.042,19.347q1.69.369,3.4.637t3.441.437l3.039-19.336Z",
    transform: "translate(-724.815 -1475.361)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2",
    "data-name": "Path 41",
    d: "M700.823,1360.76a42.82,42.82,0,1,0,50.191,69.39l.217-.158-22.155-34.354Z",
    transform: "translate(-666.965 -1336.303)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M794.43,1354.563a42.862,42.862,0,0,0-59.82-9.412l50.408,69.232A42.865,42.865,0,0,0,794.43,1354.563Z",
    transform: "translate(-700.751 -1320.694)",
    fill: "#ffd664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M8s_white_background-2",
    "data-name": "M8s white background",
    transform: "translate(33.888 32.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4167-2",
    "data-name": "Path 4167",
    d: "M780.789,1406.286a14.3,14.3,0,0,0-10.819-2.753c-.688.069-1.376,0-2.268,0,4.56-8.008,1.2-15.534-5.682-18.528-5.217-2.275-10.554-.52-15.141,2.185a28.384,28.384,0,0,0-2.695,1.807,33.061,33.061,0,0,0-6.012,5.916,16.128,16.128,0,0,0-3.441,8.534c-.382,7.344,6.332,15.007,15.486,12.574a5.407,5.407,0,0,1-.189,1.817c-3.331,6.659-2.24,12.368,3.366,17.334,3.71,3.28,8.039,4.147,12.695,3.462a23.423,23.423,0,0,0,10.689-4.866c.551-.413,1.094-.84,1.624-1.277,4.6-3.785,7.819-8.438,7.77-14.491C786.136,1413.516,784.949,1409.373,780.789,1406.286Zm-5.41,14.646a6.5,6.5,0,0,1-3.579,3.441c-.3.1-.561.193-.788.3l-.131.059a.341.341,0,0,0-.1.045l-.158.079a.707.707,0,0,0-.093.055,1.273,1.273,0,0,0-.144.093.956.956,0,0,0-.12.083,1.273,1.273,0,0,0-.165.138c-.055.055-.12.11-.179.176a3.2,3.2,0,0,0-.234.285.1.1,0,0,0-.031.042l-.083.124a3.938,3.938,0,0,0-.23.392c-.939,1.721-2.619,3.149-4.9,2.553a4.2,4.2,0,0,1-3.224-4.818c.237-3.1.688-6.174,1.122-10.025,3.865.929,7.134,1.721,10.413,2.5C775.217,1417.04,776.108,1418.953,775.379,1420.932Zm-16.174-21.8c0,.344-.031.719-.055,1.084s-.055.716-.086,1.077c-.207,2.182-.578,4.422-.891,6.938-.021.145-.034.282-.055.427-3.785-.912-7.044-1.445-10.11-2.526-2.065-.719-3.741-2.309-3.259-4.942.444-2.44,2.409-3.132,4.474-3.723l.182-.058a3.6,3.6,0,0,0,.365-.179,2.758,2.758,0,0,0,.258-.189,1.029,1.029,0,0,0,.1-.083,1.212,1.212,0,0,0,.131-.131l.072-.09.069-.107c1.466-2.533,3.531-3.565,5.778-3.011C759.246,1394.369,759.267,1396.881,759.2,1399.132Z",
    transform: "translate(-734.708 -1383.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168-2",
    "data-name": "Path 4168",
    d: "M788.378,1417.282c0,.344-.028.723-.052,1.084s-.055.715-.086,1.077c-.207,2.182-.578,4.426-.895,6.938L779.2,1415.2l.1-.086a.906.906,0,0,0,.131-.131l.072-.089.069-.1c1.466-2.536,3.531-3.568,5.778-3.011C788.423,1412.519,788.443,1415.032,788.378,1417.282Z",
    transform: "translate(-763.884 -1402.109)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169-2",
    "data-name": "Path 4169",
    d: "M828.032,1478.106a6.465,6.465,0,0,1-3.579,3.441c-.3.1-.558.193-.785.3a1.037,1.037,0,0,0-.131.059.337.337,0,0,0-.1.044c-.058.024-.1.052-.158.079a.785.785,0,0,0-.093.055,1.726,1.726,0,0,0-.148.093L815,1471.13c3.865.929,7.134,1.721,10.413,2.5C827.87,1474.217,828.765,1476.127,828.032,1478.106Z",
    transform: "translate(-787.365 -1441.132)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170-2",
    "data-name": "Path 4170",
    d: "M744.738,1410.8c-.485,2.633,1.2,4.226,3.259,4.942,3.066,1.077,6.332,1.614,10.11,2.526a3.042,3.042,0,0,1,.055-.427l4.164,5.723c-.448,3.851-.884,6.934-1.122,10.025-.182,2.357.843,4.2,3.225,4.818,2.288.6,3.968-.822,4.907-2.557.079-.141.155-.272.231-.393a1.064,1.064,0,0,1,.083-.121.092.092,0,0,1,.031-.041,3.166,3.166,0,0,1,.234-.286c.059-.065.124-.124.179-.179a1.594,1.594,0,0,1,.165-.138,1.327,1.327,0,0,1,.117-.079l6.391,8.775a23.423,23.423,0,0,1-10.7,4.869c-4.656.688-8.989-.175-12.7-3.462-5.609-4.962-6.7-10.668-3.366-17.334a5.236,5.236,0,0,0,.189-1.817c-9.154,2.437-15.868-5.227-15.486-12.567a16.175,16.175,0,0,1,3.441-8.534,33.2,33.2,0,0,1,6.015-5.916l5.85,8.022a2.194,2.194,0,0,1-.258.186,3.57,3.57,0,0,1-.365.183l-.182.058C747.147,1407.681,745.182,1408.372,744.738,1410.8Z",
    transform: "translate(-734.695 -1393.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171-2",
    "data-name": "Path 4171",
    d: "M780.789,1406.286a14.3,14.3,0,0,0-10.819-2.753c-.688.069-1.376,0-2.268,0,4.56-8.008,1.2-15.534-5.682-18.528-5.217-2.275-10.554-.52-15.141,2.185a28.384,28.384,0,0,0-2.695,1.807,33.061,33.061,0,0,0-6.012,5.916,16.128,16.128,0,0,0-3.441,8.534c-.382,7.344,6.332,15.007,15.486,12.574a5.407,5.407,0,0,1-.189,1.817c-3.331,6.659-2.24,12.368,3.366,17.334,3.71,3.28,8.039,4.147,12.695,3.462a23.423,23.423,0,0,0,10.689-4.866c.551-.413,1.094-.84,1.624-1.277,4.6-3.785,7.819-8.438,7.77-14.491C786.136,1413.516,784.949,1409.373,780.789,1406.286Zm-5.41,14.646a6.5,6.5,0,0,1-3.579,3.441c-.3.1-.561.193-.788.3-.045.021-.089.034-.131.059a2.507,2.507,0,0,0-.344.179,1.265,1.265,0,0,0-.145.093,2.191,2.191,0,0,0-.461.392,2.663,2.663,0,0,0-.238.286,1.34,1.34,0,0,0-.144.22,3.329,3.329,0,0,0-.2.344c-.94,1.721-2.619,3.149-4.9,2.557a4.206,4.206,0,0,1-3.225-4.818c.238-3.1.688-6.17,1.122-10.024,3.865.929,7.134,1.721,10.413,2.5C775.217,1417.04,776.108,1418.953,775.379,1420.932Zm-16.174-21.8c0,.3-.021.6-.041.895-.031.52-.072,1.032-.127,1.569-.031.31-.065.619-.107.936-.042.382-.093.768-.145,1.163q-.176,1.311-.372,2.705c-.072.52-.141,1.056-.213,1.607a1.793,1.793,0,0,1-.028.231c-.021.145-.034.282-.052.427-3.785-.916-7.051-1.449-10.117-2.526-2.065-.719-3.741-2.312-3.259-4.942.444-2.44,2.409-3.132,4.474-3.724a2.365,2.365,0,0,0,.809-.423l.1-.086a1.245,1.245,0,0,0,.272-.344c1.466-2.533,3.534-3.565,5.781-3.011C759.246,1394.369,759.267,1396.881,759.2,1399.132Z",
    transform: "translate(-734.708 -1383.958)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172-2",
    "data-name": "Path 4172",
    d: "M788.371,1417.25a6.567,6.567,0,0,1-.041.9c-.027.517-.072,1.033-.124,1.566-.031.313-.062.623-.107.936-.045.382-.093.768-.145,1.163-.12.878-.241,1.779-.372,2.7-.072.527-.148,1.057-.217,1.607a.753.753,0,0,1-.024.23l-8.152-11.188a1.055,1.055,0,0,0,.1-.083,1.372,1.372,0,0,0,.268-.344c1.466-2.536,3.534-3.569,5.781-3.011C788.416,1412.487,788.437,1415,788.371,1417.25Z",
    transform: "translate(-763.878 -1402.077)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173-2",
    "data-name": "Path 4173",
    d: "M828.032,1478.106a6.465,6.465,0,0,1-3.579,3.441c-.3.1-.558.193-.785.3a1.037,1.037,0,0,0-.131.059,2.485,2.485,0,0,0-.344.179,1.652,1.652,0,0,0-.148.093L815,1471.13c3.865.929,7.134,1.721,10.413,2.5C827.87,1474.217,828.765,1476.127,828.032,1478.106Z",
    transform: "translate(-787.365 -1441.132)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174-2",
    "data-name": "Path 4174",
    d: "M812.829,1471.13l8.052,11.057a2.188,2.188,0,0,0-.461.392,2.276,2.276,0,0,0-.234.286,1.387,1.387,0,0,0-.148.22,3.3,3.3,0,0,0-.2.344c-.943,1.721-2.622,3.152-4.907,2.557a4.206,4.206,0,0,1-3.224-4.818C811.938,1478.061,812.378,1474.981,812.829,1471.13Z",
    transform: "translate(-785.194 -1441.132)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175-2",
    "data-name": "Path 4175",
    d: "M768.987,1422l8.149,11.191c-.021.141-.034.282-.052.423-3.785-.909-7.048-1.445-10.114-2.526-2.065-.716-3.741-2.309-3.259-4.938.444-2.44,2.409-3.132,4.474-3.723A2.36,2.36,0,0,0,768.987,1422Z",
    transform: "translate(-753.671 -1408.909)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176-2",
    "data-name": "Path 4176",
    d: "M744.765,1410.828c-.485,2.633,1.2,4.226,3.259,4.942,3.066,1.077,6.332,1.614,10.11,2.526a3.043,3.043,0,0,1,.055-.427l4.164,5.723c-.447,3.851-.885,6.934-1.122,10.024-.182,2.357.843,4.195,3.224,4.818,2.288.6,3.968-.823,4.907-2.557a3.3,3.3,0,0,1,.2-.344,1.633,1.633,0,0,1,.148-.22,3.073,3.073,0,0,1,.234-.285,2.2,2.2,0,0,1,.461-.4l6.408,8.8a23.447,23.447,0,0,1-10.7,4.866c-4.656.688-8.989-.172-12.7-3.462-5.609-4.959-6.7-10.668-3.366-17.33a5.248,5.248,0,0,0,.19-1.817c-9.151,2.433-15.864-5.23-15.486-12.571a16.173,16.173,0,0,1,3.441-8.534,33.193,33.193,0,0,1,6.016-5.916l5.85,8.022a2.37,2.37,0,0,1-.809.423C747.174,1407.707,745.209,1408.4,744.765,1410.828Z",
    transform: "translate(-734.722 -1393.607)",
    fill: "#fdae02"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3244-3",
    "data-name": "Group 3244",
    transform: "translate(889.992 678.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76-3",
    "data-name": "Group 76",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-3",
    "data-name": "Path 29",
    d: "M1639.4,1299.277a58.567,58.567,0,0,0-35.961-14.829c-1.087-.066-2.175,3.173-3.269,3.176-1.221,0-2.44-3.228-3.647-3.159a58.592,58.592,0,0,0-35.586,14.8c-.854.767-.059,3.186-.885,4.009s-3.235,0-4.009.884a58.577,58.577,0,0,0-14.8,35.79,12.936,12.936,0,0,0,.833,3.562,11.175,11.175,0,0,0-.836,3.352,58.547,58.547,0,0,0,14.822,35.789,9.149,9.149,0,0,0,3.4,1.5l40.786-37.51,40.972-44.179A11.457,11.457,0,0,0,1639.4,1299.277Z",
    transform: "translate(-1541.126 -1284.355)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-3",
    "data-name": "Path 30",
    d: "M1677.746,1339.09,1606,1410.834s-8.493,11.766-7.63,12.526a58.552,58.552,0,0,0,35.913,14.825c1.1.055,2.206-3.166,3.318-3.169,1.208,0,2.409,3.224,3.606,3.152a58.548,58.548,0,0,0,35.631-14.8c.857-.764-1.566-4.818-.747-5.64s4.873,1.6,5.64.743a58.5,58.5,0,0,0,14.8-35.789,9.4,9.4,0,0,0-1.418-3.507,8.694,8.694,0,0,0,1.407-3.424A58.536,58.536,0,0,0,1681.7,1340C1681.042,1339.248,1677.746,1339.09,1677.746,1339.09Z",
    transform: "translate(-1578.557 -1320.194)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-3",
    "data-name": "Path 31",
    d: "M1708.993,1303.868l-.189-19.588c-1.087-.062-2.175-.1-3.266-.1q-1.827,0-3.648.114l.189,19.567Z",
    transform: "translate(-1646.492 -1284.18)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-3",
    "data-name": "Path 32",
    d: "M1598.115,1529.53l-13.844,13.841c.768.864,1.555,1.721,2.375,2.522h0l7.13-3.868,6.783-10.045Z",
    transform: "translate(-1569.349 -1445.098)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-3",
    "data-name": "Path 33",
    d: "M1607.523,1539.077l-2.447-2.447-13.917,13.917q1.228,1.235,2.519,2.374Z",
    transform: "translate(-1573.868 -1449.755)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-3",
    "data-name": "Path 34",
    d: "M1800.085,1327.56,1786.24,1341.4l2.447,2.447,9.515-6.26,4.4-7.657S1800.955,1328.324,1800.085,1327.56Z",
    transform: "translate(-1701.815 -1312.632)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-3",
    "data-name": "Path 35",
    d: "M1809.631,1336.969q-1.143-1.291-2.371-2.519l-13.92,13.916,2.446,2.447Z",
    transform: "translate(-1706.472 -1317.151)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-3",
    "data-name": "Path 36",
    d: "M1702.43,1570.144l.145,19.584q1.648.083,3.317.09,1.807,0,3.6-.11l-.148-19.567Z",
    transform: "translate(-1646.847 -1471.733)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-3",
    "data-name": "Path 37",
    d: "M1786.24,1534.424l13.845,13.844c.857-.764,1.7-1.552,2.519-2.375s1.607-1.659,2.374-2.522l-13.844-13.841Z",
    transform: "translate(-1701.815 -1445.098)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-3",
    "data-name": "Path 38",
    d: "M1603,1341.391l-13.844-13.841c-.857.768-1.7,1.552-2.519,2.375s-1.61,1.662-2.375,2.519l13.845,13.844Z",
    transform: "translate(-1569.342 -1312.625)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-3",
    "data-name": "Path 39",
    d: "M1826.85,1452.653h19.581q.1-1.72.1-3.441c0-1.163-.031-2.312-.1-3.462h-19.577Z",
    transform: "translate(-1728.45 -1390.149)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-3",
    "data-name": "Path 40",
    d: "M1560.591,1445.71h-19.578q-.1,1.72-.1,3.441,0,1.74.1,3.462h19.574Z",
    transform: "translate(-1540.91 -1390.123)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-3",
    "data-name": "Path 41",
    d: "M1660.963,1343.7a42.82,42.82,0,0,0-60.746,60.367l.189.189,30.493-27.224Z",
    transform: "translate(-1571.644 -1314.927)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-3",
    "data-name": "Path 42",
    d: "M1685.027,1428.317a42.858,42.858,0,0,0,0-60.567l-60.567,60.567A42.865,42.865,0,0,0,1685.027,1428.317Z",
    transform: "translate(-1595.708 -1338.991)",
    fill: "#ffd664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M8s_white_background-3",
    "data-name": "M8s white background",
    transform: "translate(31.436 33.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4167-3",
    "data-name": "Path 4167",
    d: "M1667.374,1426.243a14.325,14.325,0,0,0,1.032-11.119c-.175-.664-.227-1.376-.368-2.237,8.6,3.259,15.531-1.225,17.42-8.493,1.435-5.506-1.125-10.506-4.508-14.612a29.541,29.541,0,0,0-2.206-2.385,33.272,33.272,0,0,0-6.779-5.021,16.175,16.175,0,0,0-8.947-2.065c-7.316.764-13.841,8.6-10.018,17.255a5.35,5.35,0,0,1-1.824.093c-7.1-2.254-12.567-.289-16.6,6.022-2.664,4.171-2.846,8.583-1.448,13.077a23.4,23.4,0,0,0,6.469,9.8c.492.479,1,.95,1.511,1.4,4.439,3.964,9.553,6.415,15.524,5.424C1661.062,1432.648,1664.971,1430.83,1667.374,1426.243Zm-15.31-3.073a6.472,6.472,0,0,1-3.968-3c-.151-.279-.279-.523-.416-.73l-.076-.12a.407.407,0,0,0-.062-.089c-.031-.052-.066-.093-.1-.141a.868.868,0,0,0-.069-.086c-.038-.041-.075-.089-.117-.13a1.376,1.376,0,0,0-.1-.1,1.53,1.53,0,0,0-.162-.141,2.4,2.4,0,0,0-.206-.148,2.3,2.3,0,0,0-.317-.189.114.114,0,0,0-.045-.024,1.146,1.146,0,0,0-.134-.062c-.127-.059-.268-.114-.423-.169-1.855-.66-3.517-2.1-3.287-4.446a4.21,4.21,0,0,1,4.263-3.937c3.1-.244,6.195-.289,10.076-.451-.316,3.965-.6,7.32-.854,10.668C1655.883,1422.41,1654.131,1423.583,1652.063,1423.17Zm19.023-19.364c-.344.045-.716.083-1.077.117s-.719.055-1.081.079c-2.185.134-4.474.117-6.992.2h-.427c.313-3.875.344-7.186.922-10.383.389-2.14,1.7-4.054,4.374-3.988,2.478.059,3.469,1.893,4.37,3.83.031.055.055.114.086.172a3.744,3.744,0,0,0,.237.344,2.3,2.3,0,0,0,.224.224,1.29,1.29,0,0,0,.1.086,1.113,1.113,0,0,0,.148.107l.1.055.117.052c2.729,1.053,4.071,2.935,3.871,5.241C1675.794,1403.094,1673.317,1403.517,1671.087,1403.806Z",
    transform: "translate(-1632.266 -1380.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168-3",
    "data-name": "Path 4168",
    d: "M1727.631,1430.735c-.344.044-.716.082-1.08.114s-.716.058-1.077.083c-2.185.134-4.474.117-6.993.2l9.787-9.787a1.121,1.121,0,0,0,.1.086,1.67,1.67,0,0,0,.148.107l.1.055.114.052c2.732,1.053,4.074,2.935,3.875,5.241C1732.338,1430.022,1729.864,1430.446,1727.631,1430.735Z",
    transform: "translate(-1688.81 -1407.196)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169-3",
    "data-name": "Path 4169",
    d: "M1680.628,1478.295a6.47,6.47,0,0,1-3.968-3c-.152-.279-.279-.523-.417-.733-.028-.042-.048-.083-.076-.117a.409.409,0,0,0-.062-.089c-.031-.052-.065-.093-.1-.145a.542.542,0,0,0-.072-.083c-.034-.041-.072-.089-.113-.131l9.673-9.67c-.317,3.961-.6,7.316-.857,10.668C1684.444,1477.531,1682.7,1478.708,1680.628,1478.295Z",
    transform: "translate(-1660.83 -1435.392)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170-3",
    "data-name": "Path 4170",
    d: "M1666.807,1389.827c-2.677-.069-3.985,1.844-4.374,3.988-.588,3.193-.613,6.5-.922,10.382h.427l-4.986,4.99c-3.875.155-6.986.2-10.08.451-2.357.186-4.009,1.48-4.264,3.933-.237,2.354,1.432,3.786,3.286,4.45q.23.082.423.165a1.31,1.31,0,0,1,.137.062l.045.024a3.623,3.623,0,0,1,.317.189c.076.049.141.1.2.148a1.621,1.621,0,0,1,.162.141,1.33,1.33,0,0,1,.1.107l-7.677,7.677a23.445,23.445,0,0,1-6.473-9.811c-1.4-4.494-1.225-8.909,1.449-13.077,4.026-6.311,9.5-8.259,16.6-6.019a5.347,5.347,0,0,0,1.824-.093c-3.83-8.665,2.7-16.487,10.011-17.254a16.174,16.174,0,0,1,8.968,2.065,33.1,33.1,0,0,1,6.776,5.021l-7.017,7.013a2.363,2.363,0,0,1-.224-.224,3.62,3.62,0,0,1-.238-.344l-.086-.172C1670.276,1391.72,1669.285,1389.885,1666.807,1389.827Z",
    transform: "translate(-1632.264 -1380.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171-3",
    "data-name": "Path 4171",
    d: "M1667.374,1426.243a14.325,14.325,0,0,0,1.032-11.119c-.175-.664-.227-1.376-.368-2.237,8.6,3.259,15.531-1.225,17.42-8.493,1.435-5.506-1.125-10.506-4.508-14.612a29.541,29.541,0,0,0-2.206-2.385,33.272,33.272,0,0,0-6.779-5.021,16.175,16.175,0,0,0-8.947-2.065c-7.316.764-13.841,8.6-10.018,17.255a5.35,5.35,0,0,1-1.824.093c-7.1-2.254-12.567-.289-16.6,6.022-2.664,4.171-2.846,8.583-1.448,13.077a23.4,23.4,0,0,0,6.469,9.8c.492.479,1,.95,1.511,1.4,4.439,3.964,9.553,6.415,15.524,5.424C1661.062,1432.648,1664.971,1430.83,1667.374,1426.243Zm-15.31-3.073a6.472,6.472,0,0,1-3.968-3c-.151-.279-.279-.523-.416-.73a1.107,1.107,0,0,0-.076-.12,3,3,0,0,0-.23-.317c-.038-.041-.075-.089-.117-.13a2.079,2.079,0,0,0-.461-.393,2.271,2.271,0,0,0-.317-.189,1.36,1.36,0,0,0-.241-.11,3.291,3.291,0,0,0-.344-.145c-1.855-.66-3.517-2.1-3.287-4.446a4.21,4.21,0,0,1,4.264-3.937c3.1-.244,6.194-.292,10.079-.451-.316,3.964-.6,7.32-.856,10.668C1655.883,1422.41,1654.131,1423.583,1652.063,1423.17Zm19.023-19.364c-.3.034-.592.076-.891.1-.516.052-1.032.089-1.569.117-.313,0-.623.031-.943.041-.382,0-.771.027-1.171.038-.884,0-1.793.038-2.729.052l-1.621.038h-.661c.313-3.875.344-7.188.922-10.386.393-2.14,1.7-4.054,4.374-3.985,2.478.059,3.469,1.893,4.374,3.827a2.334,2.334,0,0,0,.543.736l.1.083a1.376,1.376,0,0,0,.368.217c2.729,1.053,4.071,2.935,3.871,5.241C1675.794,1403.094,1673.317,1403.517,1671.087,1403.806Z",
    transform: "translate(-1632.266 -1380.267)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172-3",
    "data-name": "Path 4172",
    d: "M1727.617,1430.709c-.3.038-.592.072-.895.1-.516.055-1.032.093-1.566.12-.313,0-.626.034-.943.038-.386.021-.775.031-1.17.041-.885,0-1.793.038-2.729.052-.53,0-1.07.021-1.621.038h-.234l9.791-9.794a1.238,1.238,0,0,0,.1.086,1.42,1.42,0,0,0,.365.217c2.732,1.053,4.074,2.935,3.871,5.241C1732.325,1430,1729.85,1430.42,1727.617,1430.709Z",
    transform: "translate(-1688.796 -1407.17)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173-3",
    "data-name": "Path 4173",
    d: "M1680.628,1478.295a6.47,6.47,0,0,1-3.968-3c-.152-.279-.279-.523-.417-.733-.028-.042-.048-.083-.076-.117a2.372,2.372,0,0,0-.234-.317c-.034-.041-.072-.089-.113-.131l9.673-9.67c-.317,3.961-.605,7.316-.857,10.668C1684.444,1477.531,1682.7,1478.708,1680.628,1478.295Z",
    transform: "translate(-1660.83 -1435.392)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174-3",
    "data-name": "Path 4174",
    d: "M1676.559,1464.33l-9.673,9.673a2.3,2.3,0,0,0-.458-.4,1.961,1.961,0,0,0-.32-.186,1.515,1.515,0,0,0-.238-.114,2.871,2.871,0,0,0-.365-.141c-1.855-.661-3.517-2.1-3.287-4.45.255-2.454,1.906-3.748,4.264-3.937C1669.573,1464.533,1672.684,1464.488,1676.559,1464.33Z",
    transform: "translate(-1651.895 -1435.392)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175-3",
    "data-name": "Path 4175",
    d: "M1727.447,1412.607l-9.791,9.791h-.427c.313-3.875.344-7.186.922-10.382.392-2.14,1.7-4.054,4.377-3.988,2.478.062,3.465,1.9,4.37,3.83A2.3,2.3,0,0,0,1727.447,1412.607Z",
    transform: "translate(-1687.99 -1398.464)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176-3",
    "data-name": "Path 4176",
    d: "M1666.8,1389.82c-2.678-.069-3.985,1.844-4.374,3.988-.588,3.193-.613,6.5-.922,10.382h.427l-4.986,4.99c-3.875.155-6.986.2-10.08.451-2.357.186-4.009,1.48-4.263,3.933-.238,2.354,1.432,3.785,3.286,4.449a2.949,2.949,0,0,1,.365.141,1.869,1.869,0,0,1,.238.11c.11.059.217.121.32.189a2.287,2.287,0,0,1,.461.393l-7.677,7.677a23.4,23.4,0,0,1-6.47-9.811c-1.4-4.474-1.225-8.906,1.445-13.077,4.03-6.314,9.5-8.279,16.6-6.019a5.277,5.277,0,0,0,1.824-.1c-3.827-8.662,2.7-16.484,10.014-17.251a16.17,16.17,0,0,1,8.968,2.065,33.093,33.093,0,0,1,6.776,5.021l-7.017,7.013a2.326,2.326,0,0,1-.544-.733C1670.273,1391.713,1669.282,1389.879,1666.8,1389.82Z",
    transform: "translate(-1632.261 -1380.24)",
    fill: "#fdae02"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.3cd07c40be486dface7ac28d75f94c73.svg";
export { ForwardRef as ReactComponent };